import jwtDecode from "jwt-decode";

const getUserNameFromToken = () => {
    const token = localStorage.getItem("access-token");

    if (token) {
        const UserName = jwtDecode(token).UserName;
        // const id = jwtDecode(token).UserId;
        return UserName;
    }
};

export default getUserNameFromToken;
